import merge from 'lodash-es/merge';
import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  production: true,
  isPendo: true,
  isLocal: false,
  envName: 'ppe',
  agGridLicenseKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-105959}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cloudmed}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{3}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_September_2027}____[v3]_[01]_MTgyMDk2MjgwMDAwMA==ce9e8e43b7cf588077928871879f59f3',
  auth0Config: {
    domain: 'auth.ppe.cloudmed.com',
    clientId: 'RbG9QlUapckamyO3zEfI7ROTOwivrvjC',
    audience: 'ppe.cloudmed',
    cmaiAudience: 'ppe.cloudmed-ai.services',
    redirectUri: window.location.origin + '/callback',
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
  },
  api: {
    ruleEngineServiceBaseURL: 'https://cmepperuleruleengineapi.azurewebsites.net',
    contractServiceBaseURL: 'https://cmeppepricingcontractapi.azurewebsites.net/api/',
    userManagementBaseUrl: 'https://cmeppewkdradminapi.azurewebsites.net',
    sparkEngineServiceBaseURL: 'https://cmepperulesparkengapi3.azurewebsites.net/api/',
    globalServiceBaseURL: 'https://cmeppepricingglobalapi.azurewebsites.net/api/',
    payerAccountabilityBaseUrl: 'https://cmeppewkdrpayeraccountabilityapi.azurewebsites.net/api',
    ruleManagementServiceBaseURL: 'https://cmepperulemanagement.azurewebsites.net',
    identificationRuleEngineBaseURL: 'https://cmepperuleidentificationruleengineapi.azurewebsites.net',
    riUserManagementUrl: 'https://usermanagementapi.ppe.cloudmed.com',
    dataApiUrl: 'https://riapi.ppe.cloudmed.com',
    cmaiContractsPricingWorkflowApi: 'https://cmeppepricingworkflowapi.azurewebsites.net/api',
  },
  ui: {
    accountInfoURL: 'https://app.ppe.cloudmed.com/account-info?id=',
    adminURL: 'https://admin.ppe.cloudmed.com/',
    contractsURL: 'https://contracts.ppe.cloudmed.com/',
  },
  sa: {
    filesURL: 'https://cmepperulegensa.z20.web.core.windows.net/',
    execResultBaseURL: 'abfss://identificationengine@cmepperuledl.dfs.core.windows.net',
  },
  appInsights: {
    instrumentationKey: 'd405d8f1-fef0-4d9f-b597-e03416229c48',
  },
};

export const environment = merge(commonEnv, env);
